/// <amd-module name="Analytics/Boards/BurndownQueries/ProjectsIterationsByDateQuery" />
import { Iteration } from "Analytics/Boards/BoardsQueries/IterationsQuery";
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import { latestODataVersion } from "Analytics/Common/Utilities/QueryUtilities";
import { BurndownQueryBase } from "./BurndownQueryBase";

import * as PublicProjectsQueryHelper from "Analytics/Common/Utilities/PublicProjectsQueryHelper";
import { QueryUtilities } from "Analytics/Common/Utilities/QueryUtilities";
import { IVssPageContext } from "VSS/Platform/Context";
import { uniqueSort } from "VSS/Platform/Util/Array";

interface ODataIteration {
    IterationSK: string;
    IterationName: string;

    /** Start of iteration: Formatted as a date string with Account Time Zone offset */
    StartDate: string;
    /** End of iteration: Formatted as a date string with Account Time Zone offset */
    EndDate: string;

    /** Iteration path: Comes in as string delimited by '\\' */
    IterationPath: string;

    /** True when the current date is beyond the iteration end date **/
    IsEnded: boolean;
}

/**
 * Gets list of iterations for a specified date range and project IDs
 */
export class ProjectsIterationsByDateQuery extends BurndownQueryBase<Iteration[]> {
    private static generateQueryOptions(pageContext: IVssPageContext, projectIDs: string[], startDate: string): ODataQueryOptions {
        const projectClause = QueryUtilities.isInArray("ProjectSK", uniqueSort(projectIDs));

        const datesClause = `date(StartDate) gt ${startDate}`;
        const $filter = `(${projectClause}) and ${datesClause}`;

        const $orderby = `IsEnded,StartDate desc,EndDate desc,IterationName`;

        const $select = `IterationSK,IterationName,StartDate,EndDate,IsEnded`;

        return PublicProjectsQueryHelper.forceProjectScoping(pageContext, projectIDs, {
            entityType: "Iterations",
            oDataVersion: latestODataVersion,
            $filter: $filter,
            $orderby: $orderby,
            $select: $select
        });
    }
    constructor(pageContext: IVssPageContext, projectIDs: string[], startDate: string, commandName?: string) {
        super(ProjectsIterationsByDateQuery.generateQueryOptions(pageContext, projectIDs, startDate), commandName);
    }

    public getQueryName(): string {
        return "ProjectsIterationsByDateQuery";
    }

    /**  Override default behavior, by reversing results  */
    protected interpretQueryResults(data: { value: ODataIteration[] }): Iteration[] {
        return data.value
            .map(odataIteration => {
                return {
                    IterationSK: odataIteration.IterationSK,
                    IterationName: odataIteration.IterationName,
                    IterationPath: odataIteration.IterationPath,
                    StartDateTimeOffset: odataIteration.StartDate,
                    EndDateTimeOffset: odataIteration.EndDate,
                    IsEnded: odataIteration.IsEnded
                };
            })
            .reverse();
    }
}
